import { HttpContextToken, HttpErrorResponse, HttpInterceptorFn } from "@angular/common/http";
import { Injector, inject } from "@angular/core";
import { Router } from "@angular/router";

import { throwError } from "rxjs";
import { catchError } from "rxjs/operators";

import { AccountService } from "@account/services/account.service";
import { UserService } from "@main/users/user.service";
import { AppStorage } from "../../utils/app-storage";

export const IGNORE_UNAUTHORIZED = new HttpContextToken(() => false);

export const httpStatusesInterceptor: HttpInterceptorFn = (req, next) => {
    const injector = inject(Injector);
    const ignoreUnauthorized = req.context.get(IGNORE_UNAUTHORIZED);

    return next(req).pipe(
        catchError((err: HttpErrorResponse) => {
            if (err.status == 401) {
                const accountService = injector.get(AccountService);
                if (accountService) {
                    const userService = injector.get(UserService);
                    const router = injector.get(Router);

                    AppStorage.setItemForSession(AppStorage.LastVisitedPageUrlKey, location.pathname);

                    if (userService.isLogged) {
                        accountService.logout();
                    } else if (!ignoreUnauthorized) {
                        if (!location.pathname.startsWith("/account")) {
                            router.navigate(["/account"]);
                        }
                    }
                }
            }

            return throwError(() => err);
        })
    );
};
